import React from 'react';
export function NewFooter() {
  return <footer className="bg-forest-deep text-white/80 py-8 text-center text-xs sm:text-sm px-4" data-id="element-135">
      <p className="mb-2" data-id="element-136">
        © 2024 Hogar Natural en Casa — Todos los derechos reservados
      </p>
      <p className="opacity-60 max-w-2xl mx-auto" data-id="element-137">
        Este producto es de carácter informativo y no reemplaza la consulta
        médica profesional.
      </p>
    </footer>;
}